import { createContext, useContext } from "react";
import { useLocation } from "react-router-dom";

type Language = "fi" | "en";

const LanguageContext = createContext<Language>("fi");

export const useLanguage = () => useContext(LanguageContext);

export const LanguageProvider = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();
  const lang: Language = location.pathname.startsWith("/en") ? "en" : "fi";
  return <LanguageContext.Provider value={lang}>{children}</LanguageContext.Provider>;
};

/** Get the path prefix for the current language */
export const useLangPrefix = () => {
  const lang = useLanguage();
  return lang === "en" ? "/en" : "";
};
